import { notify } from 'utils/reduxUtils';

export const types = {
  GEOMETRIC_ATTRIBUTES_MODAL_OPEN:
    'modules/quotes/quoteItems/modals/geometricAttributesModal/GEOMETRIC_ATTRIBUTES_MODAL_OPEN',
  GEOMETRIC_ATTRIBUTES_MODAL_CLOSE:
    'modules/quotes/quoteItems/modals/geometricAttributesModal/CLOSE_GEOMETRIC_ATTRIBUTES_MODAL',

  UPDATE_GEOMETRIC_ATTRIBUTES_ERROR:
    'modules/quotes/quoteItems/modals/geometricAttributesModal/UPDATE_GEOMETRIC_ATTRIBUTES_ERROR',
  UPDATE_GEOMETRIC_ATTRIBUTES_REQUEST:
    'modules/quotes/quoteItems/modals/geometricAttributesModal/UPDATE_GEOMETRIC_ATTRIBUTES_REQUEST',
  UPDATE_GEOMETRIC_ATTRIBUTES_SUCCESS:
    'modules/quotes/quoteItems/modals/geometricAttributesModal/UPDATE_GEOMETRIC_ATTRIBUTES_SUCCESS',
};

export const geometricAttributesModal = {
  close: () => ({
    type: types.GEOMETRIC_ATTRIBUTES_MODAL_CLOSE,
  }),
  open: ({ componentId, part }) => ({
    type: types.GEOMETRIC_ATTRIBUTES_MODAL_OPEN,
    payload: { componentId, part },
  }),
};

export const updateGeometricAttributes = {
  error: notify(
    (error) => ({
      type: types.UPDATE_GEOMETRIC_ATTRIBUTES_ERROR,
      payload: error,
    }),
    "Can't update part attributes",
  ),
  request: ({
    componentId,
    part,
    sizeX,
    sizeY,
    sizeZ,
    volume,
    area,
    units,
  }) => ({
    type: types.UPDATE_GEOMETRIC_ATTRIBUTES_REQUEST,
    payload: { componentId, part, sizeX, sizeY, sizeZ, volume, area, units },
  }),
  success: () => ({
    type: types.UPDATE_GEOMETRIC_ATTRIBUTES_SUCCESS,
  }),
};
